import * as ActionType from '../actiontypes/ActionType';

const userStatus = {
    userName: '',
    emailId: '',
    userRole: '',
    userId: '',
    parentId:'',
    userAgentApplication: null,
    accessToken:'',
    loginIdentity : ''
}
const loginReducer = (state = userStatus, action) => {
    switch (action.type) {
        case ActionType.LOGIN:
            return {
                ...state,
                userName: action.userName,
                emailId: action.emailId,
                userRole: action.userRole,
                userId: action.userId,
                parentId: action.parentId,
                userAgentApplication: action.userAgentApplication,
                accessToken:action.accessToken,
                loginIdentity : action.loginIdentity
            }
        default:
            return state;
    }
};

export default loginReducer;